import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
export const ITextResourceConfigurationService = createDecorator('textResourceConfigurationService');
export const ITextResourcePropertiesService = createDecorator('textResourcePropertiesService');
